import { Component } from "@angular/core";
import { Constants } from "../../../constants";
import { ArcusAuthService } from "../../core/arcusauth.service";
import { Observable } from "rxjs";
import { RouterLink } from "@angular/router";
import { NgClass, AsyncPipe } from "@angular/common";

@Component({
    selector: "arcus-breadcrumb",
    templateUrl: "./arcus-breadcrumb.component.html",
    styleUrl: "./arcus-breadcrumb.component.scss",
    imports: [RouterLink, NgClass, AsyncPipe],
})
export class ArcusBreadcrumbComponent {
    isLoggedIn: Observable<boolean>;
    breadcrumbNavLink: string = "";

    constructor(private authService: ArcusAuthService) {
        this.isLoggedIn = this.authService.isAuthenticated$;
    }

    get locationDisplay(): string[] {
        let path = window.location.pathname
            .substring(window.location.pathname.indexOf(Constants.baseURL) + 1)
            .split("/")
            .filter((x) => !Number(x) && Boolean(x))
            .map((x) => x.replace(/([A-Z])/g, " $1").trim());
        return path;
    }

    getBreadcrumbNavLink(loc: string) {
        const currentUrl = window.location.href;
        const id = currentUrl.substring(currentUrl.lastIndexOf("/") + 1);
        if (this.locationDisplay.includes("create")) return (this.breadcrumbNavLink = "");
        if (loc === "load" && Number(id)) return (this.breadcrumbNavLink = `/dispatch/track/${id}`);
        if (loc === "dispatch") {
            return this.locationDisplay.some((item) => item === "order" || item === "orders")
                ? `/dispatch/orders`
                : "/dispatch/loads";
        }
        if (loc === "order") return (this.breadcrumbNavLink = `/dispatch/orders`);
        if (loc === "edi") return (this.breadcrumbNavLink = `/edi/onboarding`);
    }
}
